export { default as IconA1 } from './IconA1';
export { default as IconA2 } from './IconA2';
export { default as IconA3 } from './IconA3';
export { default as IconA4 } from './IconA4';
export { default as IconA5 } from './IconA5';
export { default as IconA6 } from './IconA6';
export { default as IconA7 } from './IconA7';
export { default as IconA8 } from './IconA8';
export { default as IconA9 } from './IconA9';
export { default as IconA10 } from './IconA10';
export { default as IconA11 } from './IconA11';
export { default as IconA12 } from './IconA12';

export { default as IconB1 } from './IconB1';
export { default as IconB2 } from './IconB2';
export { default as IconB3 } from './IconB3';
export { default as IconB4 } from './IconB4';
export { default as IconB5 } from './IconB5';
export { default as IconB6 } from './IconB6';
export { default as IconB7 } from './IconB7';
export { default as IconB8 } from './IconB8';
export { default as IconB9 } from './IconB9';
export { default as IconB10 } from './IconB10';

export { default as IconC1 } from './IconC1';
export { default as IconC2 } from './IconC2';
export { default as IconC3 } from './IconC3';
export { default as IconC4 } from './IconC4';
export { default as IconC5 } from './IconC5';
export { default as IconC6 } from './IconC6';
export { default as IconC7 } from './IconC7';
export { default as IconC8 } from './IconC8';
export { default as IconC9 } from './IconC9';
